import { call, put } from 'redux-saga/effects';
import AuthorizedUserDTO from '../../../dto/AuthorizedUserDTO';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { authorizedLoginFailed, authorizedLoginSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';
import { objToForm } from '../../../utils/utils';
import { normalizeApiError } from '../../../utils/apiError';

const INACTIVE_USER_MESSAGE = 'Пользователь не активен';
const INCORRECT_CREDENTIALS_MESSAGE = 'Неверное имя пользователя или пароль';
const REQUIRED_CREDENTIALS_MESSAGE = 'Введите имя пользователя и пароль';

const getLoginErrorMessage = (data, httpStatus) => {
  const message = data?.message || data?.error?.message || '';
  if (message === INACTIVE_USER_MESSAGE || message === 'Inactive user' || message === 'User is inactive') {
    return INACTIVE_USER_MESSAGE;
  }
  if (message === 'Incorrect username or password') {
    return INCORRECT_CREDENTIALS_MESSAGE;
  }
  if (message === 'Username and password are required') {
    return REQUIRED_CREDENTIALS_MESSAGE;
  }
  return normalizeApiError({ ...data, httpStatus }).message;
};

export default function* authorizedLogin(action) {
  try {
    // todo need refact client model and this code
    const client = new AuthorizedUserDTO(action.payload);
    const url = `${BACKEND_URL}/auth/login`;
    const pool = objToForm(client.getLoginData());
    const userDataResponse = yield makeRequest(url, pool, action, 'POST', false, {}, true);
    const authorizedData = yield userDataResponse.json();
    if (userDataResponse?.status === OK && authorizedData?.data?.access) {
      window.localStorage.clear();
      yield put(authorizedLoginSuccessful(authorizedData.data));
      yield call(resolveActionPromise(action, authorizedData.data));
    } else {
      const errorMessage = getLoginErrorMessage(authorizedData, userDataResponse?.status);
      yield put(authorizedLoginFailed());
      yield call(rejectActionPromise(action, errorMessage || authorizedData));
    }
  } catch (e) {
    yield put(authorizedLoginFailed(e));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
